import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './FinancialInsuranceInfoDataForm.html?raw';
import on from 'dojo/on';
import Edit from '../../../moreCore/UI/Edit/Edit';
import '../../../moreCore/UI/Edit/Edit';
import CollapsibleSection from '../CollapsibleSection/CollapsibleSection';
import SelectBox from '../../../moreCore/UI/SelectBox/SelectBox';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import HintBox from '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import Button from '../../../moreCore/UI/Button/Button';

class FinancialInsuranceInfoDataForm extends compose(_WidgetBaseSP) {
    templateString: any = template;
    isReadonly: boolean = false;
    isDirty: boolean = false;

    financialDataFormErrorContainer: HTMLElement;
    financialDataFormErrorMessage: HTMLElement;

    allFurtherAddresses: Array<IndividualData_FurtherAddress>;
    addressSelect: MdsLax<InstanceType<typeof SelectBox>>;

    SocialInsuranceNumberInput: MdsLax<InstanceType<typeof Edit>>;
    TaxNumberInput: MdsLax<InstanceType<typeof Edit>>;
    TaxIdNumberInput: MdsLax<InstanceType<typeof Edit>>;
    VatNumberInput: MdsLax<InstanceType<typeof Edit>>;
    VatExemptionCheckbox: MdsLax<InstanceType<typeof CheckBox>>;
    IsTaxMainAddressCheckbox: MdsLax<InstanceType<typeof CheckBox>>;
    SelectTaxAddressCheckbox: MdsLax<InstanceType<typeof CheckBox>>;

    DescriptionInput: MdsLax<InstanceType<typeof Edit>>;
    StreetInput: MdsLax<InstanceType<typeof Edit>>;
    PostalCodeInput: MdsLax<InstanceType<typeof Edit>>;
    CityInput: MdsLax<InstanceType<typeof Edit>>;
    CountryInput: MdsLax<InstanceType<typeof SearchSelect>>;

    PostalCodeHintBox: MdsLax<InstanceType<typeof HintBox>>;
    postalCodeSectionMessageContainer: HTMLElement;
    postalCodeSectionMessage: HTMLElement;

    saveNewAddressBtn: MdsLax<InstanceType<typeof Button>>;
    newAddressErrorContainer: HTMLElement;
    newAddressErrorMessage: HTMLElement;

    readonlyIsActive: HTMLInputElement;
    readonlyIsTaxAddress: HTMLInputElement;
    readonlyStreetInfo: HTMLInputElement;
    readonlyPostalCodeInfo: HTMLInputElement;
    readonlyCityInfo: HTMLInputElement;
    readonlyCountryInfo: HTMLInputElement;
    btn_setAsActiveInactive: HTMLElement;


    newTaxAddressContainer: HTMLElement;
    selectedAddressInfoContainer: HTMLElement;
    selectTaxAddressCheckboxcontainer: HTMLElement;

    formData: IndividualData_FinancialInsuranceDataSave = {

        social_insurance_no: "",
        tax_no: "",
        tax_id_no: "",
        VAT_no: "",
        is_VAT_exemption: false,
        is_contact_address_tax_address: false,
        further_address_id: ""
    };
    originalData: string = "";

    newAddressData: IndividualData_NewFurtherAddressSave = {
        description: "",
        street: "",
        postal_code_id: "",
        postal_code: "",
        city: "",
        country_id: ""
    };

    loadFormData(data: IndividualData_FinancialInsuranceInfo): void {
        
        this.prepareFurtherAddressSection(data.further_addresses);

        this.fillFinancialData(data.financial_insurance_data);

        this.createNewAddressSection();

        this.serializeFormData(data);

        this.originalData = JSON.stringify(this.formData);
        console.debug(this.originalData);
    }

    prepareFurtherAddressSection(data: Array<IndividualData_FurtherAddress>, refreshAddress?: string): void {

        this._showErrorMessage(false);

        this.allFurtherAddresses = data;
        this.allFurtherAddresses.length > 0 ? this.addressSelect.setPlaceholder(this.translations["FormLabel_FurtherAddresses_placeholder"]) : this.addressSelect.setPlaceholder(this.translations["FormLabel_FurtherAddresses_placeholder_empty"]);

        this.addressSelect.clear();

        data.forEach(address => {

            this.addressSelect.addOption(address.ID, `${address.street}, ${address.ref_postal_code.postal_code} ${address.ref_postal_code.city}`);
            if (address.is_active_tax_address) this.addressSelect.setValue(address.ID, true);
        });

        this.addressSelect.constructOptions();
        if (refreshAddress) this.addressSelect.setValue(refreshAddress);

        this.constructAddressInfo(this.addressSelect.getValue());
    }

    constructAddressInfo(addressId: string): void {

        let address: IndividualData_FurtherAddress = this.allFurtherAddresses.filter(x => x.ID === addressId)[0];
        
        if (address) {

            this.UiModder.domClass.remove(this.selectedAddressInfoContainer, "w3-hide");

            if (address.is_active) {

                this.readonlyIsActive.value = this.translations["General_Yes"];
                this.btn_setAsActiveInactive.innerHTML = this.translations["Btn_SetAsInactive"];
                this.UiModder.domAttr.set(this.btn_setAsActiveInactive, "attr_set_active_inactive", "set_inactive");

                this.UiModder.domClass.remove(this.selectTaxAddressCheckboxcontainer, "w3-hide");
            } else {

                this.readonlyIsActive.value = this.translations["General_No"];
                this.btn_setAsActiveInactive.innerHTML = this.translations["Btn_SetAsActive"];
                this.UiModder.domAttr.set(this.btn_setAsActiveInactive, "attr_set_active_inactive", "set_active");

                this.UiModder.domClass.add(this.selectTaxAddressCheckboxcontainer, "w3-hide");
                this.SelectTaxAddressCheckbox.setValue(false);
            }

            if (address.is_active_tax_address) {

                this.readonlyIsTaxAddress.value = this.translations["General_Yes"];
                if (!this.IsTaxMainAddressCheckbox.getValue()) this.SelectTaxAddressCheckbox.setValue(true, true);
            } else {

                this.readonlyIsTaxAddress.value = this.translations["General_No"];
                this.SelectTaxAddressCheckbox.setValue(false, true);
            }

            this.readonlyStreetInfo.value = address.street;
            this.readonlyPostalCodeInfo.value = address.ref_postal_code.postal_code;
            this.readonlyCityInfo.value = address.ref_postal_code.city;
            this.readonlyCountryInfo.value = address.ref_country.description;

        } else {

            this.UiModder.domClass.add(this.selectedAddressInfoContainer, "w3-hide");
        }

        this.addressSelect.StandbyStop();
    }

    fillFinancialData(data: IndividualData_FinancialData): void {

        this.SocialInsuranceNumberInput.setValue(data.social_insurance_no, true);
        this.TaxNumberInput.setValue(data.tax_no, true);
        this.TaxIdNumberInput.setValue(data.tax_id_no, true);
        this.VatNumberInput.setValue(data.VAT_no, true);
        this.VatExemptionCheckbox.setValue(data.is_VAT_exemption, true);
        this.IsTaxMainAddressCheckbox.setValue(data.is_contact_address_tax_address, true);
    }

    createNewAddressSection(): void {

        this.DescriptionInput = new Edit();
        this.StreetInput = new Edit();
        this.PostalCodeInput = new Edit();
        this.CityInput = new Edit();
        this.CountryInput = new SearchSelect();
        this.PostalCodeHintBox = new HintBox();
        this.saveNewAddressBtn = new Button();
        this.DescriptionInput.setCyName("FinancialInsurance:Description");
        this.StreetInput.setCyName("FinancialInsurance:Street");
        this.PostalCodeInput.setCyName("FinancialInsurance:PostalCode");
        this.CityInput.setCyName("FinancialInsurance:City");
        this.CountryInput.setCyName("FinancialInsurance:Country");
        this.PostalCodeHintBox.setCyName("FinancialInsurance:PostalCodeHintBox");
        this.saveNewAddressBtn.setCyName("FinancialInsurance:saveNewAddressBtn");

        this.UiModder.domConstruct.empty(this.newTaxAddressContainer);

        let cs = new CollapsibleSection();

        cs.sectionName = "new_address_section";
        cs.isEditable = false;
        cs.collapsibleHeading.innerHTML = this.translations["FormLabel_Collapsible_NewFurtherAddress"];
        cs.placeAt(this.newTaxAddressContainer);

        this.UiModder.domConstruct.empty(cs.collapsibleContainer);

        //DESCRIPTION
        let div = this.UiModder.domConstruct.create("div", { class: "w3-container w3-padding" }, cs.collapsibleContainer);

        this.DescriptionInput.setLabel(this.translations["FormLabel_ShortDescription"]);
        this.DescriptionInput.setMandatory(true);
        this.UiModder.domClass.add(this.DescriptionInput.domNode, "w3-half");
        this.DescriptionInput.placeAt(div);

        on(this.DescriptionInput, "change", lang.hitch(this, this._onChange_newFurtherAddressData));

        //STREET
        div = this.UiModder.domConstruct.create("div", { class: "w3-container w3-padding" }, cs.collapsibleContainer);

        this.StreetInput.setLabel(this.translations["FormLabel_Street"]);
        this.StreetInput.setMandatory(true);
        this.UiModder.domClass.add(this.StreetInput.domNode, "w3-half");
        this.StreetInput.placeAt(div);

        on(this.StreetInput, "change", lang.hitch(this, this._onChange_newFurtherAddressData));


        //POSTAL CODE, CITY, COUNTRY
        div = this.UiModder.domConstruct.create("div", { class: "w3-container w3-padding w3-half" }, cs.collapsibleContainer);

        this.PostalCodeHintBox.setLabel(this.translations["FormLabel_PostalCode_HintBox"]);
        this.PostalCodeHintBox._setPlaceholderAttr(this.translations["FormLabel_PostalCode_HintBox_Placeholder"]);
        this.PostalCodeHintBox.minLetterCount = 3;
        this.PostalCodeHintBox.dataFormat = "json";
        this.PostalCodeHintBox.setLabelAttribute("gDisp_1");
        this.PostalCodeHintBox.requestUrlSearchParameter = "searchText";
        this.PostalCodeHintBox.setUrl("IndividualDataSheet/GetPostalCodeHintboxValues");
        this.PostalCodeHintBox.resetOnEdit = true;
        this.UiModder.domClass.add(this.PostalCodeHintBox.domNode, "w3-half");
        this.PostalCodeHintBox.placeAt(div);

        on(this.PostalCodeHintBox, "valueChange", lang.hitch(this, this._onChange_PostalCodeHintBox));

        this.postalCodeSectionMessageContainer = this.UiModder.domConstruct.create("div", {
            class: "w3-row w3-padding w3-round w3-pale-yellow w3-text-deep-purple w3-hide flex_row_center",
            style: "flex-wrap:nowrap"
        }, div);

        this.UiModder.domConstruct.create("div", {
            innerHTML: `<i class="fa fa-exclamation w3-margin-right">&nbsp;</i>`
        }, this.postalCodeSectionMessageContainer);

        this.postalCodeSectionMessage = this.UiModder.domConstruct.create("div", {
            innerHTML: this.translations["IndividualDataSheet_ContactData_PostalCodeMessage"]
        }, this.postalCodeSectionMessageContainer);

        let postalCodeDiv = this.UiModder.domConstruct.create("div", {
            class: "w3-container w3-padding"
        }, div);

        this.PostalCodeInput.setLabel(this.translations["FormLabel_PostalCode"]);
        this.PostalCodeInput.setReadonly(true);
        this.UiModder.domClass.add(this.PostalCodeInput.domNode, "w3-row w3-padding");
        this.UiModder.domClass.add(this.PostalCodeInput.labelNode, "w3-col m2");
        this.UiModder.domClass.add(this.PostalCodeInput.inputNode, "w3-twothird");
        this.PostalCodeInput.placeAt(postalCodeDiv);
        on(this.PostalCodeInput, "change", lang.hitch(this, this._onChange_newFurtherAddressData));

        this.CityInput.setLabel(this.translations["FormLabel_City"]);
        this.CityInput.setReadonly(true);
        this.UiModder.domClass.add(this.CityInput.domNode, "w3-row w3-padding");
        this.UiModder.domClass.add(this.CityInput.labelNode, "w3-col m2");
        this.UiModder.domClass.add(this.CityInput.inputNode, "w3-twothird");
        this.CityInput.placeAt(postalCodeDiv);
        on(this.CityInput, "change", lang.hitch(this, this._onChange_newFurtherAddressData));

        div = this.UiModder.domConstruct.create("div", { class: "w3-row w3-padding" }, postalCodeDiv);

        this.CountryInput.valueAttribute = "ID";
        this.CountryInput.labelAttribute = "description";
        this.CountryInput.setDropDownPositionAbsolute(false);
        this.CountryInput.setUrl("IndividualDataSheet/GetCountryListValues");
        this.CountryInput._setReadonlyAttr(true);

        this.UiModder.domConstruct.create("label", { innerHTML: this.translations["FormLabel_Country"], class: "w3-col m2" }, div);
        this.UiModder.domClass.add(this.CountryInput.domNode, "w3-twothird");
        this.CountryInput.loadListValues();
        this.CountryInput.placeAt(div);
        on(this.CountryInput, "change", lang.hitch(this, this._onChange_newFurtherAddressData));

        //Save Btn
        div = this.UiModder.domConstruct.create("div", { class: "w3-container w3-padding" }, cs.collapsibleContainer);

        this.saveNewAddressBtn.setLabel(this.translations["General_Save"]);
        this.saveNewAddressBtn.setClasses("mds-button-base w3-padding w3-disabled round mds-hover-bright accentBG", " ");
        this.saveNewAddressBtn.setIconLeft("fas fa-save");
        this.saveNewAddressBtn.on("click", lang.hitch(this, this._onClick_saveNewAddressBtn));
        this.saveNewAddressBtn.placeAt(div);

        //Error container
        this.newAddressErrorContainer = this.UiModder.domConstruct.create("div", {
            class: "w3-container w3-padding w3-round w3-pale-red w3-text-red w3-hide flex_row_center w3-margin",
            style: "flex-wrap:nowrap"
        }, cs.collapsibleContainer);

        this.UiModder.domConstruct.create("div", {
            class: "w3-text-red",
            innerHTML: '<i class="fa fa-exclamation-triangle">&nbsp;</i>'
        }, this.newAddressErrorContainer);

        this.newAddressErrorMessage = this.UiModder.domConstruct.create("div", {}, this.newAddressErrorContainer);

    }

    serializeNewAddressData(): void {

        let valid = true;

        this.newAddressData.description = this.DescriptionInput.getValue();
        if (!this.newAddressData.description) valid = false;

        this.newAddressData.street = this.StreetInput.getValue();
        if (!this.newAddressData.street) valid = false;

        let postalCode: string | IndividualData_PostalCode = this.PostalCodeHintBox.getValue();

        switch (typeof (postalCode)) {
            case "object":

                postalCode ? this.newAddressData.postal_code_id = postalCode.ID : this.newAddressData.postal_code_id = "";
                break;
            default:

                this.newAddressData.postal_code_id = "";
                break;
        }

        this.newAddressData.postal_code = this.PostalCodeInput.getValue();
        if (!this.newAddressData.postal_code) valid = false;

        this.newAddressData.city = this.CityInput.getValue();
        if (!this.newAddressData.city) valid = false;

        this.newAddressData.country_id = this.CountryInput.getValue();
        if (!this.newAddressData.country_id) valid = false;

        if (valid) {

            this.saveNewAddressBtn.setClasses(" ", "w3-disabled");
            this._showNewAddressErrorMessage(false);
        } else {

            this.saveNewAddressBtn.setClasses("w3-disabled", " ");
        }

        console.debug("NEW ADDRESS DATA", this.newAddressData)
    }

    serializeFormData(data?: IndividualData_FinancialInsuranceInfo): void {

        data ? this.formData.social_insurance_no = data.financial_insurance_data.social_insurance_no : this.formData.social_insurance_no = this.SocialInsuranceNumberInput.getValue();
        data ? this.formData.tax_no = data.financial_insurance_data.tax_no : this.formData.tax_no = this.TaxNumberInput.getValue();
        data ? this.formData.tax_id_no = data.financial_insurance_data.tax_id_no : this.formData.tax_id_no = this.TaxIdNumberInput.getValue();
        data ? this.formData.VAT_no = data.financial_insurance_data.VAT_no : this.formData.VAT_no = this.VatNumberInput.getValue();
        data ? this.formData.is_VAT_exemption = data.financial_insurance_data.is_VAT_exemption : this.formData.is_VAT_exemption = this.VatExemptionCheckbox.getValue();
        data ? this.formData.is_contact_address_tax_address = data.financial_insurance_data.is_contact_address_tax_address : this.formData.is_contact_address_tax_address = this.IsTaxMainAddressCheckbox.getValue();

        if (data) {

            if (data.further_addresses.length > 0) {

                let id = data.further_addresses.filter(x => x.is_active_tax_address === true)[0]?.ID;

                if (id) this.formData.further_address_id = id; else this.formData.further_address_id = "";
            }
        } else {

            if (this.SelectTaxAddressCheckbox.getValue()) this.formData.further_address_id = this.addressSelect.getValue(); else this.formData.further_address_id = "";
        }

        console.debug("SERIALIZE DATA:", this.formData);
        if (!data) this.checkDirty();//???
        console.debug("isDirty:", this.isDirty);

        if (this.isValid()) this._showErrorMessage(false);
    }

    _onChange_newFurtherAddressData():void {

        this.serializeNewAddressData();
    }

    _onChange_PostalCodeHintBox(): void {
        
        let hintboxValue = this.PostalCodeHintBox.getValue();

        switch (typeof (hintboxValue)) {
            case "object":

                this.PostalCodeInput.setReadonly(true);
                this.CityInput.setReadonly(true);
                this.CountryInput._setReadonlyAttr(true);

                this.UiModder.domClass.add(this.postalCodeSectionMessageContainer, "w3-hide");
                this.UiModder.domClass.remove(this.PostalCodeInput.inputNode, "w3-pale-yellow");
                this.UiModder.domClass.remove(this.CityInput.inputNode, "w3-pale-yellow");
                //this.UiModder.domClass.remove(this.CountryInput.outerInput, "w3-pale-yellow");

                let postalCode: IndividualData_PostalCode = this.PostalCodeHintBox.getValue();

                if (postalCode) this.PostalCodeInput.setValue(postalCode.postal_code, true);
                if (postalCode) this.CityInput.setValue(postalCode.city, true);
                if (postalCode) this.CountryInput.setValue(postalCode.ref_country.ID, true);

                break;
            default:

                if (this.PostalCodeHintBox.getValue("entity") !== null && this.PostalCodeHintBox.getValue("value") !== null) {

                    this.PostalCodeInput.setReadonly(false);
                    this.CityInput.setReadonly(false);
                    this.CountryInput._setReadonlyAttr(false);

                    this.UiModder.domClass.remove(this.postalCodeSectionMessageContainer, "w3-hide");
                    this.UiModder.domClass.add(this.PostalCodeInput.inputNode, "w3-pale-yellow");
                    this.UiModder.domClass.add(this.CityInput.inputNode, "w3-pale-yellow");
                    //this.UiModder.domClass.add(this.CountryInput.outerInput, "w3-pale-yellow");

                    this.PostalCodeInput.setValue("");
                    this.CityInput.setValue("");
                    this.CountryInput.setValue("");
                }
                break;
        }

        this.serializeNewAddressData();
    }

    _onClick_saveNewAddressBtn(): void {

        let requestUrl = window.appRoot + "IndividualDataSheet/SaveFormData";
        this.StandbyStart();

        this.RequestManager.post(
            requestUrl,
            {
                jsonData: JSON.stringify(this.newAddressData),
                sectionName: IndividualData_SectionName.NewFurtherAddress
            },
            lang.hitch(this, this._onSaveNewAddressDataResponse),
            lang.hitch(this, this._onSaveNewAddressDataError),
            false // sync
        );
    }

    _onSaveNewAddressDataResponse(response: any): void {

        //this.StandbyStop();
        this.createNewAddressSection();
        this.refreshFurtherAddressData();

        setTimeout(() => {
            this.addressSelect.StandbyStart();
            this.addressSelect.setValue(response.addressId);
            this.StandbyStop();
        }, 1500);
    }

    _onClick_saveBtn(): void {

        if (this.isValid()) {

            let requestUrl = window.appRoot + "IndividualDataSheet/SaveFormData";
            this.StandbyStart();

            this.RequestManager.post(
                requestUrl,
                {
                    jsonData: JSON.stringify(this.formData),
                    sectionName: IndividualData_SectionName.FinancialInsuranceInfo
                },
                lang.hitch(this, this._onSaveFormDataResponse),
                lang.hitch(this, this._onSaveFormDataError),
                false // sync
            );
        }
    }

    _onSaveFormDataResponse(): void {

        this.StandbyStop();

        let dlg = new GenericDialog();

        dlg.destroyOnClose = true;
        this.UiModder.domStyle.set(dlg.modalDlgContentNode, "width", "600px");
        this.UiModder.domStyle.set(dlg.modalDlgContentNode, "margin-top", "100px");

        dlg.show(this.translations["FormDialog_Document_Save_Message"], this.translations["FormDialog_Save_Header"], null, "fas fa-info-circle", "ok");

        this.emit("DataForm_close");
    }

    isValid(): boolean {

        let b: boolean = true;

        if (this.IsTaxMainAddressCheckbox.getValue() === true && this.SelectTaxAddressCheckbox.getValue() === true) {

            this.UiModder.domClass.add(this.IsTaxMainAddressCheckbox.domNode, "w3-pale-red");
            this.UiModder.domClass.add(this.SelectTaxAddressCheckbox.domNode, "w3-pale-red");
            b = false;
        } else {

            this.UiModder.domClass.remove(this.IsTaxMainAddressCheckbox.domNode, "w3-pale-red");
            this.UiModder.domClass.remove(this.SelectTaxAddressCheckbox.domNode, "w3-pale-red");
        }

        return b;
    }

    checkDirty(): void {

        this.isDirty = JSON.stringify(this.formData) !== this.originalData;

        this.emit("change_isDirty", this.isDirty);
    }

    _onChangeInsuranceDataInput(): void {

        this.serializeFormData();
    }

    _onClick_setAsActiveInactiveBtn(): void {

        if (this.SelectTaxAddressCheckbox.getValue() === true) this.SelectTaxAddressCheckbox.setValue(false);

        let mode = this.UiModder.domAttr.get(this.btn_setAsActiveInactive, "attr_set_active_inactive");
        let msg = "";

        switch (mode) {
            case "set_active":
                msg = this.translations["FormDialog_Form_setAsActive"];
                break;
            case "set_inactive":
                msg = this.translations["FormDialog_Form_setAsInaktive"];
                break;
        }

        let dlg = new GenericDialog();

        dlg.show(msg, this.translations["FormLabel_IsAktive"], null, "fas fa-question", "yesno", lang.hitch(this, this.setAddressAsActiveInactive));
        dlg.destroyOnClose = true;
        this.UiModder.domStyle.set(dlg.modalDlgContentNode, "width", "600px");
        this.UiModder.domStyle.set(dlg.modalDlgContentNode, "margin-top", "100px");
    }

    setAddressAsActiveInactive(dlgResult: any): void {

        if (dlgResult === 2) {

            let requestUrl = window.appRoot + "IndividualDataSheet/SetAddressAsActiveInactive";
            this.StandbyStart();

            this.RequestManager.post(
                requestUrl,
                {
                    addressId: this.addressSelect.getValue()
                },
                lang.hitch(this, this._onSetAddressAsActiveInactiveResponse),
                lang.hitch(this, this._onSetAddressAsActiveInactiveError),
                false // sync
            );
        }
    }

    _onSetAddressAsActiveInactiveResponse() {

        this.refreshFurtherAddressData();
    }

    refreshFurtherAddressData(): void {

        let requestUrl = window.appRoot + "IndividualDataSheet/GetSectionDataByName";

        this.RequestManager.post(
            requestUrl,
            {
                sectionName: IndividualData_SectionName.FinancialInsuranceInfo
            },
            lang.hitch(this, this._onRefreshDataResponse),
            lang.hitch(this, this._onRefreshDataError),
            false // sync
        );
    }

    _onRefreshDataResponse(data: IndividualData_FinancialInsuranceInfo) {

        this.StandbyStop();
        let addressValue = this.addressSelect.getValue();

        this.prepareFurtherAddressSection(data.further_addresses, addressValue);

        this.serializeFormData();
    }

    _onChange_SelectedAddress(): void {

        this.constructAddressInfo(this.addressSelect.getValue());
        this.serializeFormData();
    }

    _onChangeIsTaxMainAddressCheckbox(): void {

        let bool = this.IsTaxMainAddressCheckbox.getValue();
        if (bool) this.SelectTaxAddressCheckbox.setValue(false, true);
        this.serializeFormData();
    }

    _onChangeSelectTaxAddressCheckbox(): void {

        let bool = this.SelectTaxAddressCheckbox.getValue();
        if (bool) this.IsTaxMainAddressCheckbox.setValue(false, true);
        this.serializeFormData();
    }

    _onSetAddressAsActiveInactiveError(err) {

        this.StandbyStop();
        this._showErrorMessage(true, err.Message);
    }

    _onSaveFormDataError(err) {

        this.StandbyStop();
        this._showErrorMessage(true, err.Message);
    }

    _onRefreshDataError(err) {

        this.StandbyStop();
        this._showErrorMessage(true, err.Message);
    }

    private _showErrorMessage(show: boolean, msg?: string): void {

        if (show) {

            this.UiModder.domClass.remove(this.financialDataFormErrorContainer, "w3-hide");
            msg ? this.financialDataFormErrorMessage.innerHTML = msg : this.financialDataFormErrorMessage.innerHTML = "...error occured";
        } else {

            this.UiModder.domClass.add(this.financialDataFormErrorContainer, "w3-hide");
            this.financialDataFormErrorMessage.innerHTML = "";
        }
    }

    _onSaveNewAddressDataError(err) {

        this.StandbyStop();
        this._showNewAddressErrorMessage(true, err.Message);
    }

    private _showNewAddressErrorMessage(show: boolean, msg?: string): void {

        if (show) {

            this.UiModder.domClass.remove(this.newAddressErrorContainer, "w3-hide");
            msg ? this.newAddressErrorMessage.innerHTML = msg : this.newAddressErrorMessage.innerHTML = "...error occured";
        } else {

            this.UiModder.domClass.add(this.newAddressErrorContainer, "w3-hide");
            this.newAddressErrorMessage.innerHTML = "";
        }
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

mdsLazyProto(FinancialInsuranceInfoDataForm.prototype, {
  saveNewAddressBtn: () => (new Button()),
});
export default mdsWidget(FinancialInsuranceInfoDataForm);